const work_info = [
  {
    image: 'https://drive.google.com/uc?id=1y4FHIxV73xwaWKb4EEtBW9suffXdnpun',
    alt: 'Keyboard Arena',
    company: 'KEYBOARD ARENA',
    role: 'Head Organising Member',
    period: 'Oct 2021-Oct 2021',
    desc: 'Head organising member of Keyboard Arena, a one of a kind friendly speed typing competition with over 200 participants.',
  },
  {
    image: 'https://drive.google.com/uc?id=1y4FHIxV73xwaWKb4EEtBW9suffXdnpun',
    alt: 'Codechef-SRM-NCR',
    company: 'CODECHEF SRM NCR CHAPTER',
    role: 'Core Team Member(CP Team)',
    period: 'May 2021-Jul 2023',
    desc: 'Responsible for setting problems for various online inter-college coding contests/events held on Codechef by Codechef SRM NCR Chapter for our peers so that they can improve their problem solving skills in a paced-environment.',
  },
  // {
  //   image: 'https://merivis.org/wp-content/uploads/2018/02/Amazon-Logo-Transparent-PNG-300x300.png',
  //   alt: 'Amazon-image',
  //   company: 'Amazon',
  //   role: 'Software Developer - 1',
  //   period: '2018-2019',
  //   desc: 'Amazon is awesome',
  // },
];

export default work_info;